export const scrollToUnvisibleSlide = (index, slider) => {
  if (index < 0 || !slider) return
  const activeSlide = slider.slides[index]
  if (!activeSlide) return
  const sliderWrapper = slider.el
  const DOMrectSlide = activeSlide.getBoundingClientRect()
  const DOMrectSWrapper = sliderWrapper.getBoundingClientRect()

  const isScrollLeft = DOMrectSlide.x < DOMrectSWrapper.x
  const isScrollRight = (DOMrectSWrapper.x + DOMrectSWrapper.width) < (DOMrectSlide.x + DOMrectSlide.width)

  if (isScrollLeft || isScrollRight) {
    slider.slideTo(index, 1000)
  }
}
